module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAMAAAAs2N9uAAAAZlBMVEUAAABUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGaK+OfmAAAAIXRSTlMAA/l7I9rJu6qIgmtQ7eZZG/XVkHJCOzgs89OhZEYuEgrFq6dKAAAAhUlEQVQY02WQRxaDMAxExwUMpoYS0pO5/yVj47KAv9PX05NG8Iih6tmVdkTiWjAgVTStpHwO26pcpxLe3C586DCvSAuHYfFFRFFqQJMtEmJiDTTsRFYzSYWaBhlXLTgobPCDPQ5o8o1M2GQ4/ZJpuMRTyzEaSZsC3edVf16lD3SKvZvzc/7mFAnTjcDafwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_turn_r.png
// module id = nqV9
// module chunks = 9